'use strict';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';
import {getLink} from '../../core-utilities/domain/ReduxUtils';
import * as TASK_TYPE from '../enums/TASK_TYPE';
import {getScheduleStatus} from '../domain/utils';

TasksFilterService.$inject = [];

export function TasksFilterService() {
  this.filterOnStatus = removeByStatus;
  this.filterOnAssignmentStatus = removeByAssignmentStatus;
  this.filterOnProjectLevelAssociation = removeByProjectLevelAssociation;
}

export function removeByStatus(task, options) {
  // Assignment filters
  // TODO: convert to accept a task or date instead?
  const status = task && task.status ? task.status : 'pending';

  if (!options.status[status]) return true;

  return false;
}

/** @deprecated */
export const filterOnStatus = removeByStatus;

export function removeByAssignmentStatus(task, options) {
  // Assignment filters
  const calStat = getScheduleStatus(task);
  const calStatFilter = options.calStat || options.scheduleStatus;

  if (!calStatFilter[calStat]) return true;

  // Date Filters
  let filterDate;
  switch (task.status) {
    case 'submitted':
    case 'approved':
      filterDate = getDateTime(task.submittedOn);
      break;
    case 'cancelled':
      filterDate = getDateTime(task.cancelledOn);
      break;
    default:
      filterDate = getDateTime(task.scheduled);
      break;
  }

  if (options.dateRange.useAfter
    && (!isNumber(filterDate)
    || (isNumber(filterDate) && options.dateRange.afterDate && (filterDate < options.dateRange.afterDate.getTime()))))
    return true;
  if (options.dateRange.useBefore
    && (!isNumber(filterDate)
    || (isNumber(filterDate) && options.dateRange.beforeDate && (filterDate > options.dateRange.beforeDate.getTime()))))
    return true;

  return false;
}

function getDateTime(val) {
  return isDate(val) ? val.getTime() : val;
}

/** @deprecated */
export const filterOnAssignmentStatus = removeByAssignmentStatus;

// Filter by whether this is a project or asset specific task
export function removeByProjectLevelAssociation(task, options, taskType) {
  let parentTask;
  switch (taskType) {
    case TASK_TYPE.SITE:
      parentTask = getLink(task, 'task'); // This asset task is the child of a project task

      // Task filters
      if (!options.tasks.project && (parentTask && parentTask.id)) return true;

      if (!options.tasks.asset && (!parentTask || !parentTask.id)) return true;

      break;
  }

  return false;
}

export const filterOnProjectLevelAssociation = removeByProjectLevelAssociation;



// WEBPACK FOOTER //
// ./src/js/tasks/filters/TasksFilterService.js